export const MAP_API_KEY = 'pk.eyJ1IjoidGVyYWJpdCIsImEiOiJja21zMnpkaXMwZGdqMm5teDdpNWN1ZHVkIn0.mIPDv8iZ1mMEq51n6jt10g'

export const DEV_MODE = false

export const DISCORD_LINK = 'https://discord.gg/KXrEkCk4Tm'

export const GOOGLE_OAUTH2_KEY = "149175887871-7b719rdu9vdi4ov3uuoj29harti7usr4.apps.googleusercontent.com"

